import {
  BadgeCheck,
  HardHat,
  PlugZap,
  Smartphone,
  Mic,
  LifeBuoy,
} from "lucide-react";
import { WHY_GENIEX } from "../../data/content";

const ICONS = { BadgeCheck, HardHat, PlugZap, Smartphone, Mic, LifeBuoy };

export default function WhyGenieX({ onBook }) {
  return (
    <section
      data-testid="why-geniex"
      className="relative bg-[var(--gx-bg)] py-24 lg:py-40 border-t border-line/60"
    >
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10">
        <div className="grid lg:grid-cols-[1fr_1.2fr] gap-12 lg:gap-20 items-end mb-16 lg:mb-24">
          <div>
            <p className="eyebrow mb-5">Why GenieX</p>
            <h2 className="h1-display text-white max-w-[14ch]">
              Built for the way<br />
              <span className="text-gold">you actually live.</span>
            </h2>
          </div>
          <p className="lead max-w-[56ch]">
            We don't sell smart home gadgets. We design intelligent homes — privately consulted,
            quietly installed, and personally cared for, for life.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-line/60 border border-line/60 rounded-3xl overflow-hidden">
          {WHY_GENIEX.map((w, i) => {
            const Icon = ICONS[w.icon] || BadgeCheck;
            return (
              <article
                key={w.title}
                className="bg-[var(--gx-surface)] hover:bg-[var(--gx-elev)] transition-colors p-8 lg:p-10 min-h-[200px] flex flex-col gap-5"
              >
                <div className="flex items-center justify-between">
                  <span className="w-11 h-11 rounded-full bg-[var(--gx-elev)] border border-line flex items-center justify-center">
                    <Icon className="w-4 h-4 text-gold" />
                  </span>
                  <span className="text-[11px] tracking-[0.28em] text-mute">0{i + 1}</span>
                </div>
                <div>
                  <h3 className="font-display text-xl lg:text-2xl text-white tracking-tight">
                    {w.title}
                  </h3>
                  <p className="text-[13.5px] text-dim mt-2 max-w-[34ch] leading-relaxed">
                    {w.sub}
                  </p>
                </div>
              </article>
            );
          })}
        </div>

        {/* Closing CTA */}
        <div className="mt-20 lg:mt-28 relative overflow-hidden rounded-3xl border border-line/70 bg-gradient-to-br from-[#16161B] via-[#0E0E12] to-[#08080A]">
          <div
            className="absolute inset-0 opacity-30"
            style={{
              backgroundImage:
                "url('/renders/dynamic-lifestyle.png'), url('https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=2000&q=85')",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/85 to-black/30" />
          <div className="relative px-7 lg:px-16 py-16 lg:py-24 grid lg:grid-cols-[1.4fr_1fr] gap-10 items-end">
            <div>
              <p className="eyebrow mb-5">A Private Consultation</p>
              <h3 className="h1-display text-white max-w-[16ch]">
                The future of your home, designed in 30 minutes.
              </h3>
              <p className="lead mt-6 max-w-[48ch]">
                Free, private, and refreshingly honest. We come to you across Telangana & Andhra,
                or meet virtually from anywhere in India.
              </p>
            </div>
            <div className="flex flex-col gap-3">
              <button
                onClick={onBook}
                data-testid="why-book-cta"
                className="btn-gold w-full"
              >
                Book a Consultation
              </button>
              <a href="tel:+919063662999" className="btn-outline w-full">
                Or call +91 90636 62999
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
